
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import StandardFooter from '@/components/layout/StandardFooter';

interface ProfilePageWrapperProps {
  children: React.ReactNode;
}

const ProfilePageWrapper: React.FC<ProfilePageWrapperProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 pt-24 px-6 pb-16">
        <div className="max-w-7xl mx-auto">
          <Button 
            variant="ghost" 
            asChild
            className="mb-6 text-redflags-gray hover:text-redflags-dark"
          >
            <Link to="/companies" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Back to Company Profiles
            </Link>
          </Button>
          
          {children}
        </div>
      </main>
      
      <StandardFooter />
    </div>
  );
};

export default ProfilePageWrapper;
